export default __webpack_public_path__ + "static/media/USDT-BNB.71b27eea.svg";